import { BASE_CONFIG } from './base.config';
import urls from './urls.config.json';
import { AppVariants } from '@store/models/generic.model';

/**
 * DOE variant configuration for all environments
 * URLs are imported from urls.config.json (single source of truth)
 */

export const DOE_CONFIG = {
  BASE_CONFIG,
  variant: AppVariants.DOE,
  clientId: 'doedst-fe-client',

  /** Mock/local development environment */
  mock: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.doe.doorstroomtoets.mock',
      CloudRoleName: 'cito-doe.dst-app-fe-mock',
    },
    BFF: {
      ApiUrl: urls.mock.doe.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.mock.doe.authUrl,
      ClientId: 'doedst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.mock.doe.authUrl,
      ClientId: 'doedst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.mock.doe.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'DOEDST',
    },
    // Skip authentication if configured (e.g., for running locally with mocks and/or E2E testing)
    skipAuth: true,
    mockUser: {
      email: 'test@example.com',
      name: 'Test User',
      roles: ['APPBHR', 'FBH', 'TEBH'],
    },
  },

  /** Test environment */
  test: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.doe.doorstroomtoets',
      CloudRoleName: 'cito-doe.dst-app-fe-o',
    },
    BFF: {
      ApiUrl: urls.doe.test.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.doe.test.authUrl,
      ClientId: 'doedst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.doe.test.authUrl,
      ClientId: 'doedst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.doe.test.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'DOEDST',
    },
  },

  /** Acc environment */
  acc: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.doe.doorstroomtoets',
      CloudRoleName: 'cito-doe.dst-app-fe-a',
    },
    BFF: {
      ApiUrl: urls.doe.acc.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.doe.acc.authUrl,
      ClientId: 'doedst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.doe.acc.authUrl,
      ClientId: 'doedst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.doe.acc.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'DOEDST',
    },
  },

  /** Production environment */
  production: {
    PrimeNGLicenseToken: BASE_CONFIG.primeNGLicenseToken,
    ApplicationInsights: {
      InstrumentationKey: BASE_CONFIG.applicationInsightsKey,
      ApplicationName: 'Cito.doe.doorstroomtoets',
      CloudRoleName: 'cito-doe.dst-app-fe-o',
    },
    BFF: {
      ApiUrl: urls.doe.production.bffUrl,
    },
    Auth: {
      AuthorityUrl: urls.doe.production.authUrl,
      ClientId: 'doedst-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    AuthIntern: {
      AuthorityUrl: urls.doe.production.authUrl,
      ClientId: 'doedst-intern-fe-client',
      Scopes: BASE_CONFIG.commonScopes,
    },
    VisualisatieService: {
      Url: urls.doe.production.visualisatieServiceUrl,
    },
    DST: {
      DatumX: '2024-01-01T00:00:00.000',
      DatumY: '2024-01-29T00:00:00.000',
      ProductBusinessKey: 'DOEDST',
    },
  },
};
